class BloodPressure {
    public systolic: number;
    public diastolic: number;

    constructor(fields?: Partial<BloodPressure>) {
        Object.assign(this, fields);
    }

    public hasValue(): boolean {
        return !!this.systolic
            || !!this.diastolic;
    }
}

export { BloodPressure };
